import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GraphMap } from '../interfaces/graph-node.interface';

export interface StoreFilters {
  search?: string;
  ownedByMe?: boolean;
  managedByMe?: boolean;
  addedByMe?: boolean;
  templates?: boolean;
}

export interface StoreLibraryEntry {
  id: string;
  addedAt: Date;
  map: GraphMap;
  user: { id: string };
}

export interface MapStoreEntry {
  id: string;
  publishedAt: Date;
  map: GraphMap;
  publishedBy: { id: string };
}

@Injectable({ providedIn: 'root' })
export class StoreResource {
  private baseUrl = environment.apiUrl + '/store';

  constructor(private httpClient: HttpClient) {}

  getPublishedMaps(filters?: StoreFilters): Observable<GraphMap[]> {
    let params = new HttpParams();
    if (filters?.search) {
      params = params.set('search', filters.search);
    }
    if (filters?.ownedByMe) {
      params = params.set('ownedByMe', 'true');
    }
    if (filters?.managedByMe) {
      params = params.set('managedByMe', 'true');
    }
    if (filters?.addedByMe) {
      params = params.set('addedByMe', 'true');
    }
    if (filters?.templates) {
      params = params.set('templates', 'true');
    }
    return this.httpClient.get<GraphMap[]>(this.baseUrl + '/maps', { params });
  }

  publishMap(mapId: string, thumbnailUrl?: string): Observable<MapStoreEntry> {
    let params = new HttpParams();
    if (thumbnailUrl) {
      params = params.set('thumbnailUrl', thumbnailUrl);
    }
    return this.httpClient.post<MapStoreEntry>(this.baseUrl + '/publish/' + mapId, {}, { params });
  }

  unpublishMap(mapId: string): Observable<{ message: string }> {
    return this.httpClient.delete<{ message: string }>(this.baseUrl + '/unpublish/' + mapId);
  }

  addToLibrary(mapId: string): Observable<StoreLibraryEntry> {
    return this.httpClient.post<StoreLibraryEntry>(this.baseUrl + '/library/' + mapId, {});
  }

  removeFromLibrary(mapId: string): Observable<{ message: string }> {
    return this.httpClient.delete<{ message: string }>(this.baseUrl + '/library/' + mapId);
  }

  getUserLibrary(): Observable<GraphMap[]> {
    return this.httpClient.get<GraphMap[]>(this.baseUrl + '/library');
  }

  isInLibrary(mapId: string): Observable<{ inLibrary: boolean }> {
    return this.httpClient.get<{ inLibrary: boolean }>(this.baseUrl + '/library/' + mapId + '/status');
  }

  isPublished(mapId: string): Observable<{ isPublished: boolean }> {
    return this.httpClient.get<{ isPublished: boolean }>(this.baseUrl + '/maps/' + mapId + '/status');
  }
}
